"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toCustComponents = exports.transformCustoComp = exports.createComponentsTransformation = exports.toCustoTexts = exports.toCustoFns = exports.toCustoHooks = void 0;
const prop_1 = require("../../utils/prop");
const hook_1 = require("../hook");
const texts_1 = require("../texts");
const __1 = require("../..");
const components_1 = require("../components");
const react_1 = __importDefault(require("react"));
const set_1 = require("../../utils/set");
const utils_1 = require("../../utils");
const toCustoFnOrHooks = (type, obj, flag) => {
    return prop_1.deepMapObject(obj, val => {
        if (val instanceof hook_1.CustoHook) {
            return {
                stop: true,
                newVal: val,
            };
        }
        if (typeof val === "function") {
            return {
                stop: true,
                newVal: flag === "functions"
                    ? type === __1.CustoType.component
                        ? hook_1.CustoHook.createComponentFn(val)
                        : type === __1.CustoType.data
                            ? hook_1.CustoHook.createDataFn(val)
                            : type === __1.CustoType.text
                                ? hook_1.CustoHook.createTextFn(val)
                                : hook_1.CustoHook.createFn(val)
                    : type === __1.CustoType.component
                        ? hook_1.CustoHook.createComponentHook(val)
                        : type === __1.CustoType.data
                            ? hook_1.CustoHook.createDataHook(val)
                            : type === __1.CustoType.text
                                ? hook_1.CustoHook.createTextHook(val)
                                : hook_1.CustoHook.createHook(val),
            };
        }
        if (val === null || typeof val !== "object") {
            return {
                stop: true,
                newVal: val,
            };
        }
        return { stop: false };
    });
};
exports.toCustoHooks = (type, obj) => {
    return toCustoFnOrHooks(type, obj, "hooks");
};
exports.toCustoFns = (type, obj) => {
    return toCustoFnOrHooks(type, obj, "functions");
};
///
exports.toCustoTexts = (obj) => {
    return prop_1.deepMapObject(obj, val => {
        if (utils_1.isCustoClass(val)) {
            return {
                stop: true,
                newVal: val,
            };
        }
        if (typeof val === "string" ||
            typeof val === "number" ||
            val === null) {
            return {
                stop: true,
                newVal: texts_1.CustoText.create(val),
            };
        }
        if (val === null || typeof val !== "object") {
            return {
                stop: true,
                newVal: val,
            };
        }
        return { stop: false };
    });
};
///
exports.createComponentsTransformation = (defaultProps, options = {}) => {
    return (obj) => {
        return prop_1.deepMapObject(obj, val => {
            if (val instanceof __1.CustoComponent) {
                return {
                    stop: true,
                    newVal: exports.transformCustoComp(val, defaultProps, options),
                };
            }
            else if (val instanceof hook_1.CustoHook &&
                val.type == __1.CustoType.component) {
                const cloned = val.clone();
                const transformationFn = cloned.transformationFn;
                cloned.transformationFn = data => {
                    const transformedData = (transformationFn
                        ? transformationFn(data)
                        : data);
                    return exports.transformCustoComp(transformedData, defaultProps, options);
                };
                //
                return {
                    stop: true,
                    newVal: cloned,
                };
            }
            else if (utils_1.isCustoClass(val)) {
                return {
                    stop: true,
                    newVal: val,
                };
            }
            if (isReactComponent(val)) {
                return {
                    stop: true,
                    newVal: __1.CustoComponent.create(val, defaultProps, options),
                };
            }
            if (val === null || typeof val !== "object") {
                return {
                    stop: true,
                    newVal: val,
                };
            }
            return { stop: false };
        });
    };
};
exports.transformCustoComp = (comp, defaultProps, options) => {
    const newComp = comp.clone();
    newComp.defaultProps = components_1.mergeValueOrFn(defaultProps, newComp.defaultProps || {}, (v1, v2) => (Object.assign(Object.assign({}, v1), v2)));
    const keys = Object.keys(options);
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        const oldVal = newComp[key];
        if (oldVal === undefined) {
            newComp[key] = options[key];
        }
    }
    const iterableValueKeys = [
        "labels",
        "stripPropKeys",
        "additionalMergeFlags",
        "subtractiveMergeFlags",
    ];
    for (let i = 0; i < iterableValueKeys.length; i++) {
        const key = iterableValueKeys[i];
        if (!options.hasOwnProperty(key))
            continue;
        const oldVal = newComp[key];
        if (options[key] === oldVal || !oldVal)
            continue;
        newComp[key] = mergeIterables(options[key], oldVal);
    }
    return newComp;
};
const mergeIterables = (a, b) => {
    if (a instanceof Set || b instanceof Set) {
        return set_1.unionWith.call(new Set(a), b);
    }
    return [...a, ...b];
};
const isReactComponent = (e) => {
    return (typeof e === "function" ||
        e instanceof react_1.default.Component ||
        e instanceof react_1.default.PureComponent ||
        (typeof e === "object" && e && e["$$typeof"]));
};
exports.toCustComponents = exports.createComponentsTransformation({});
